import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth-context.js';
import { Spinner } from './Spinner.js';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading, accessDenied } = useAuth();
  const location = useLocation();
  if (accessDenied) {
    return <Navigate to="/access-denied" replace />;
  }
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
